export default __webpack_public_path__ + "static/media/Q5_2.1d29783f.png";